__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "fashinza";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] ||= {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult?.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("@fashinza/fashinza-design-system", "1.10.3-beta.44", () => (() => (__webpack_require__(21665))), 1);
			register("@pathofdev/react-tag-input", "1.0.7", () => (() => (__webpack_require__(54998))), 1);
			register("@paypal/react-paypal-js", "5.2.0", () => (() => (__webpack_require__(38710))), 1);
			register("@popperjs/core", "2.11.8", () => (() => (__webpack_require__(48986))), 1);
			register("@sentry/react", "5.30.0", () => (() => (__webpack_require__(30992))), 1);
			register("compressorjs", "1.3.0", () => (() => (__webpack_require__(15450))), 1);
			register("connected-react-router", "6.9.3", () => (() => (__webpack_require__(4598))), 1);
			register("copy-to-clipboard", "3.3.3", () => (() => (__webpack_require__(29042))), 1);
			register("crypto-js", "4.2.0", () => (() => (__webpack_require__(11059))), 1);
			register("date-fns", "2.30.0", () => (() => (__webpack_require__(5041))), 1);
			register("downshift", "6.1.12", () => (() => (__webpack_require__(97180))), 1);
			register("fecha", "4.2.3", () => (() => (__webpack_require__(51696))), 1);
			register("framer-motion", "10.18.0", () => (() => (__webpack_require__(59386))), 1);
			register("history", "4.10.1", () => (() => (__webpack_require__(19760))), 1);
			register("immutable", "4.3.9", () => (() => (__webpack_require__(87043))), 1);
			register("js-cookie", "2.2.1", () => (() => (__webpack_require__(54836))), 1);
			register("linkifyjs", "2.1.9", () => (() => (__webpack_require__(10557))), 1);
			register("linkifyjs", "4.3.3", () => (() => (__webpack_require__(70425))), 1);
			register("lodash", "4.18.1", () => (() => (__webpack_require__(11956))), 1);
			register("match-sorter", "6.3.4", () => (() => (__webpack_require__(34124))), 1);
			register("mdast-util-find-and-replace", "1.1.1", () => (() => (__webpack_require__(17223))), 1);
			register("mdast-util-find-and-replace", "2.2.2", () => (() => (__webpack_require__(37694))), 1);
			register("mixpanel-browser", "2.83.0", () => (() => (__webpack_require__(64140))), 1);
			register("prop-types", "15.8.1", () => (() => (__webpack_require__(87881))), 1);
			register("qs", "6.16.0", () => (() => (__webpack_require__(62208))), 1);
			register("raf", "3.4.1", () => (() => (__webpack_require__(28397))), 1);
			register("react-aria-menubutton", "6.3.0", () => (() => (__webpack_require__(77202))), 1);
			register("react-autocomplete", "1.8.1", () => (() => (__webpack_require__(17113))), 1);
			register("react-beautiful-dnd", "13.1.1", () => (() => (__webpack_require__(32327))), 1);
			register("react-color", "2.19.3", () => (() => (__webpack_require__(40791))), 1);
			register("react-day-picker", "7.4.10", () => (() => (__webpack_require__(14074))), 1);
			register("react-dom", "18.3.1", () => (() => (__webpack_require__(21706))), 1);
			register("react-error-boundary", "3.1.4", () => (() => (__webpack_require__(44269))), 1);
			register("react-file-utils", "1.2.0", () => (() => (__webpack_require__(26151))), 1);
			register("react-helmet", "6.1.0", () => (() => (__webpack_require__(19697))), 1);
			register("react-lottie", "1.2.10", () => (() => (__webpack_require__(75870))), 1);
			register("react-markdown", "5.0.3", () => (() => (__webpack_require__(64624))), 1);
			register("react-markdown", "8.0.7", () => (() => (__webpack_require__(56378))), 1);
			register("react-multi-carousel", "2.8.6", () => (() => (__webpack_require__(82796))), 1);
			register("react-places-autocomplete", "7.3.0", () => (() => (__webpack_require__(15030))), 1);
			register("react-popper", "2.3.0", () => (() => (__webpack_require__(4416))), 1);
			register("react-quill", "2.0.0", () => (() => (__webpack_require__(79955))), 1);
			register("react-rating-stars-component", "2.2.0", () => (() => (__webpack_require__(86773))), 1);
			register("react-redux", "7.2.9", () => (() => (__webpack_require__(56845))), 1);
			register("react-router-dom", "5.3.4", () => (() => (__webpack_require__(8306))), 1);
			register("react-router", "5.3.4", () => (() => (__webpack_require__(74703))), 1);
			register("react-sizeme", "2.6.12", () => (() => (__webpack_require__(82469))), 1);
			register("react-swipeable-views", "0.13.9", () => (() => (__webpack_require__(31535))), 1);
			register("react-table-sticky", "1.1.3", () => (() => (__webpack_require__(19441))), 1);
			register("react-table", "7.8.0", () => (() => (__webpack_require__(9554))), 1);
			register("react-tag-autocomplete", "6.3.0", () => (() => (__webpack_require__(62372))), 1);
			register("react-textarea-autosize", "8.5.9", () => (() => (__webpack_require__(37240))), 1);
			register("react-toastify", "5.5.0", () => (() => (__webpack_require__(532))), 1);
			register("react-toastify", "9.1.3", () => (() => (__webpack_require__(93342))), 1);
			register("react-toggle", "4.1.3", () => (() => (__webpack_require__(72939))), 1);
			register("react-tooltip-lite", "1.12.0", () => (() => (__webpack_require__(68993))), 1);
			register("react-transition-group", "4.4.5", () => (() => (__webpack_require__(18720))), 1);
			register("react-virtualized", "9.22.6", () => (() => (__webpack_require__(58797))), 1);
			register("react", "18.3.1", () => (() => (__webpack_require__(5247))), 1);
			register("recharts", "2.15.4", () => (() => (__webpack_require__(88543))), 1);
			register("redux-devtools-extension", "2.13.9", () => (() => (__webpack_require__(12751))), 1);
			register("redux-thunk", "2.4.2", () => (() => (__webpack_require__(74072))), 1);
			register("redux", "4.2.1", () => (() => (__webpack_require__(26841))), 1);
			register("stream-chat-react", "10.22.3", () => (() => (__webpack_require__(27238))), 1);
			register("stream-chat", "8.61.0", () => (() => (__webpack_require__(13867))), 1);
			register("styled-components", "5.3.11", () => (() => (__webpack_require__(56835))), 1);
			register("styled-components", "6.5.3", () => (() => (__webpack_require__(23735))), 1);
			register("use-scan-detection", "0.2.3", () => (() => (__webpack_require__(66622))), 1);
			register("uuid", "7.0.3", () => (() => (__webpack_require__(60824))), 1);
			register("with-router", "1.0.1", () => (() => (__webpack_require__(41706))), 1);
			register("xlsx", "0.18.5", () => (() => (__webpack_require__(61936))), 1);
			register("zod", "3.25.76", () => (() => (__webpack_require__(69851))), 1);
			initExternal(10471);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};